import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"

import { BlockThirdParty, Video, transformLinkUri } from "gatsby-theme-gba"

const VideoEditable = ({ blok }) => {
  const backgroundImage = "/block-3rd-party-placeholder.jpg"

  let video = blok.video

  video = video.linktype === "url" ? video.url : video.cached_url

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }

  const replaceAll = (str, term, replacement) =>
    str.replace(new RegExp(escapeRegExp(term), "g"), replacement)

  const videoElement = (
    <Video video={video} reverse={blok.reverse} poster={blok.poster}>
      <Markdown
        transformLinkUri={(uri) => {
          return transformLinkUri(uri, "", blok.currentLanguage)
        }}
      >
        {replaceAll(blok.body, "\u2028", "")}
      </Markdown>
    </Video>
  )

  let link = ""
  if (blok.infoUrl) {
    link = blok.infoUrl.id
      ? transformLinkUri(blok.infoUrl.id, "", blok.currentLanguage)
      : blok.infoUrl.cached_url
  }

  if (blok.block3rdParty !== "true") {
    return (
      <div {...storyblokEditable(blok)} key={blok._uid}>
        {videoElement}
      </div>
    )
  }
  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <BlockThirdParty
        cookieKey={blok.cookieKey}
        backgroundUrl={backgroundImage}
        buttonText={blok.buttonText}
        buttonPermanentText={blok.buttonPermanentText}
        infoText={blok.infoText}
        infoUrl={link}
        infoUrlText={blok.infoUrlText}
      >
        {videoElement}
      </BlockThirdParty>
    </div>
  )
}

export default VideoEditable
